import { useCallback, useEffect } from 'react';
import { useObservable } from 'react-use-observable';

import { FilterOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

import type { FormikProps } from 'formik';
import { Field, Form, Formik } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import leadsService from 'v2/services/leads/list';
import tableService from 'v2/services/table';

import initialValues, { getInitialValues } from './initialValues';

const leadTypes = [
  {
    label: 'Todos',
    value: ''
  },
  {
    label: 'Abandono de carrinho',
    value: true
  },
  {
    label: 'Clicou em comprar',
    value: false
  }
];

const Filter = () => {
  useEffect(() => {
    leadsService.loadAffiliates();
    leadsService.loadCampaigns();
  }, []);

  const [isLoading] = useObservable(() => tableService.isLoading(), []);

  const [affiliates] = useObservable(() => leadsService.getAffiliates(), []);

  const [campaigns] = useObservable(() => leadsService.getCampaigns(), []);

  const onSubmit = useCallback((values: typeof initialValues, { setSubmitting }: FormikProps<typeof initialValues>) => {
    leadsService.setFilter({ ...values });
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ isValid, isSubmitting, dirty, resetForm }: FormikProps<typeof initialValues>) => {
        const handleClearFilter = () => {
          const clearedValues = getInitialValues();
          resetForm({ values: clearedValues });
          leadsService.cleanFilter();
        };

        return (
          <Form id='leads-filter' data-testid='leads-filter' className='mb-4 w-full rounded-sm bg-white p-4'>
            <div>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={8}>
                  <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Field
                    id='product_id'
                    name='product_id'
                    fullWidth
                    label='Produtos'
                    endpoint='/reports/leads/products'
                    component={SelectProduct}
                  />
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Field
                    id='affiliate_id'
                    name='affiliate_id'
                    multiple
                    options={affiliates}
                    fullWidth
                    label='Afiliados'
                    component={SelectFormField}
                  />
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Field
                    id='campaign_id'
                    name='campaign_id'
                    multiple
                    options={campaigns}
                    fullWidth
                    label='Campanhas'
                    component={SelectFormField}
                  />
                </Col>
                <Col xs={24} sm={12} md={8}>
                  <Field
                    id='abandonment'
                    name='abandonment'
                    options={leadTypes}
                    fullWidth
                    label='Tipo de lead'
                    component={SelectFormField}
                  />
                </Col>
                <Col xs={12} md={4} className='flex items-end md:pt-5'>
                  <Button
                    id='clear-button'
                    disabled={!dirty || isSubmitting || isLoading}
                    type='text'
                    block
                    onClick={handleClearFilter}
                    loading={isLoading || isSubmitting}
                  >
                    <span id='clear-button-label'>Limpar</span>
                  </Button>
                </Col>
                <Col xs={12} md={4} className='flex items-end md:pt-5'>
                  <Button
                    id='basic-filter-button'
                    type='primary'
                    disabled={!isValid || isSubmitting || isLoading}
                    block
                    htmlType='submit'
                    loading={isLoading || isSubmitting}
                    icon={<FilterOutlined id='basic-filter-button-icon' />}
                  >
                    <span id='basic-filter-button-label'>Filtrar</span>
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default Filter;
